import Icon from '../Icon'
import Loader from '../Loader'
import { PointerIcon, PointerText, PointerWrapper } from './Pointer.styles'

interface PointerProps {
  children: React.ReactNode
  isLoading?: boolean
}

const Pointer = ({ children, isLoading }: PointerProps) => {
  return (
    <PointerWrapper>
      <PointerText>{children}</PointerText>
      {isLoading && <Loader />}
      {!isLoading && (
        <PointerIcon>
          <Icon name="angle-down" />
          <Icon name="angle-down" />
        </PointerIcon>
      )}
    </PointerWrapper>
  )
}

export default Pointer
